export default "__VITE_PUBLIC_ASSET__1e03e5de__"